"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeReactive = makeReactive;

var _vue = _interopRequireDefault(require("vue"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var mVue = _vue["default"];

function makeReactive(obj) {
  var cur = obj;
  var propBlacklist = ['constructor'];
  var _data = {};
  var computed = {};
  var wrapper = Object.create(obj);
  var allProps = [];

  while (cur !== Object.getPrototypeOf({})) {
    var curProps = Object.getOwnPropertyNames(cur).filter(function (prop) {
      return propBlacklist.indexOf(prop) === -1 && allProps.indexOf(prop) === -1;
    });
    allProps.push.apply(allProps, _toConsumableArray(curProps)); // eslint-disable-next-line no-loop-func

    curProps.forEach(function (prop) {
      var _Object$getOwnPropert = Object.getOwnPropertyDescriptor(cur, prop),
          get = _Object$getOwnPropert.get,
          set = _Object$getOwnPropert.set;

      if (get) {
        if (set) {
          computed[prop] = {
            get: get.bind(wrapper),
            set: set.bind(wrapper)
          };
        } else {
          computed[prop] = get.bind(wrapper);
        }
      } else if (typeof obj[prop] === 'function') {
        return;
      } else {
        _data[prop] = obj[prop];
      }
    });
    cur = Object.getPrototypeOf(cur);
  }

  var vm = new mVue({
    data: function data() {
      return _data;
    },
    computed: computed
  });
  allProps.forEach(function (prop) {
    /* eslint-disable no-prototype-builtins */
    if (_data.hasOwnProperty(prop)) {
      Object.defineProperty(wrapper, prop, {
        enumerable: true,
        get: function get() {
          return vm[prop];
        },
        set: function set(value) {
          vm[prop] = value;
        }
      });
    } else if (computed.hasOwnProperty(prop)) {
      Object.defineProperty(wrapper, prop, {
        enumerable: true,
        get: function get() {
          return vm[prop];
        },
        set: function set(value) {
          vm[prop] = value;
          return value;
        }
      });
    }
  });

  wrapper.$watch = function () {
    return vm.$watch.apply(vm, arguments);
  };

  wrapper.$vm = vm;
  return wrapper;
}

makeReactive.install = function (Vue) {
  mVue = Vue;
};